import React, { Component, Fragment } from 'react';
import DynamicPageRedirectRuleForm from './DynamicPageRedirectRuleForm';
import { FieldTypes } from 'drapcode-constant';
import {
  collectionItemOption,
  getEventCollectionFieldOptions,
  getSessionOptions,
  pageCollectionOption,
  previousStepOption,
} from './util';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export default class DynamicPageRedirectRule extends Component {
  state = {
    collectionFieldValueOptions: [],
  };

  componentDidMount = () => {
    this.setCollecctionValuesOptions();
  };

  shouldComponentUpdate = (nextProps, nextState, nextContext) => {
    if (this.props.selectedFieldName !== nextProps.selectedFieldName) {
      this.setCollecctionValuesOptions();
    }
    return true;
  };

  setCollecctionValuesOptions = async () => {
    let options = [];
    const { selectedCollectionName, selectedFieldName, collections, projectId, version } =
      this.props;
    const selectedCollection = collections.find((e) => e.collectionName === selectedCollectionName);
    const selectedCollectionFields = selectedCollection ? selectedCollection.fields : [];
    const selectedField = selectedCollectionFields.find((e) => e.fieldName === selectedFieldName);
    if (!selectedField) {
      this.setState({ collectionFieldValueOptions: options });
      return;
    }
    if (selectedField.type === FieldTypes.static_option.id) {
      selectedField.staticOptions.forEach((e) => options.push({ value: e, label: e }));
    } else if (selectedField.type === FieldTypes.dynamic_option.id) {
      const header = builderSurfaceJsonContentHeader(projectId);
      const { collectionName, collectionField } = selectedField.refCollection;
      await axios
        .get(`${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/`, header)
        .then((res) => {
          if (Array.isArray(res.data)) {
            res.data.forEach((item) => {
              if (item[collectionField]) {
                options.push({
                  value: item[collectionField],
                  label: item[collectionField],
                });
              }
            });
          }
        });
    }
    this.setState({ collectionFieldValueOptions: options });
  };

  getPageOptions = () => {
    const { pages } = this.props;
    const pageOptions =
      pages.length > 0 ? pages.map((item) => ({ value: item.slug, label: item.name })) : [];
    return pageOptions;
  };

  getPathFieldsOptions = () => {
    const { collections, selectedCollectionName, collectionFrom } = this.props;
    const collectionFromArr = ['page', 'collections', 'collectionForm'];
    const collectionFromSessionArr = ['session', 'sessionActionResponse'];
    let options = !collectionFromSessionArr.includes(collectionFrom)
      ? getEventCollectionFieldOptions(selectedCollectionName, collections, FieldTypes.uuid.id)
      : [collectionItemOption];
    let extraOptions = getSessionOptions(collections, FieldTypes.uuid.id);
    extraOptions = [pageCollectionOption, previousStepOption, ...extraOptions];
    return [...options, ...extraOptions];
  };

  getSeoFieldsOptions = () => {
    const { collections, selectedCollectionName, collectionFrom } = this.props;
    const collectionFromArr = ['session', 'sessionActionResponse'];
    let options = !collectionFromArr.includes(collectionFrom)
      ? getEventCollectionFieldOptions(selectedCollectionName, collections, FieldTypes.text.id)
      : [];

    let sessionOptions = getSessionOptions(collections, FieldTypes.text.id);
    return [...options, ...sessionOptions];
  };

  getFieldCollectionSourceOptions = () => {
    const { collectionFrom } = this.props;
    const options = [
      { value: 'default', label: 'Default' },
      // { value: 'pageCollection', label: 'Page/Snippet' },
    ];

    if (collectionFrom === 'collectionForm') {
      options.push({ value: 'cmsCollection', label: 'Data Group/List/Table' });
    } else {
      options.push({ value: 'formCollection', label: 'Collection Form' });
    }
    return options;
  };

  render() {
    const {
      createNewParamRow,
      params,
      selectedCollection,
      selectedCollectionField,
      collections,
      collectionFrom,
    } = this.props;
    return (
      <Fragment>
        <div className="table-responsive">
          <table className="table table-sm table-bordered table-condensed">
            <thead style={{ fontWeight: 'bold' }}>
              <tr>
                <td className="text-left w-20">Field Value</td>
                <td className="text-left">Page</td>
                <td className="text-left w-10">Target</td>
                <td className="text-left">Path Field</td>
                {collectionFrom !== 'sessionActionResponse' && (
                  <>
                    <td className="text-left">Seo Field</td>
                  </>
                )}
                <td className="text-left w-20">Collection From</td>
              </tr>
            </thead>
            <tbody>
              {params.map((row) => {
                return (
                  <DynamicPageRedirectRuleForm
                    paramRow={row}
                    key={row.id}
                    createNewRow={createNewParamRow}
                    selectedCollection={selectedCollection}
                    selectedCollectionField={selectedCollectionField}
                    collections={collections}
                    collectionFieldValueOptions={this.state.collectionFieldValueOptions}
                    pageOptions={this.getPageOptions()}
                    pathFieldOptions={this.getPathFieldsOptions()}
                    seoFieldOptions={this.getSeoFieldsOptions()}
                    fieldCollectionSourceOptions={this.getFieldCollectionSourceOptions()}
                    collectionFrom={collectionFrom}
                  />
                );
              })}
            </tbody>
          </table>
        </div>
      </Fragment>
    );
  }
}
